<template>
  <a-row :gutter="[24, 24]">
    <a-col
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
      :md="{ span: 24 }"
      :xl="{ span: 20, offset: 2 }"
      :lg="{ span: 20, offset: 2 }"
    >
      <div>
        <a-card
          size="small"
          style="margin-top: 10px; border-radius: 5px; border-color: #c9c9c9"
          hoverable
          :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
        >
          <a slot="title" class="guider" style="font-size: 20px">
            DrawCorrHeatmap
          </a>
          <a-row :gutter="[12, 12]">
            <a-col :span="8">
              <div>
                <div style="width: 100%; margin-top: 15px">
                  Step 1 : Click to select a dataset:
                  <br />
                  <div
                    style="height: 650px; overflow-y: auto; text-align: center"
                  >
                    <a-button
                      type="primary"
                      style="margin-top: 12px; width: 80%"
                      block
                      v-for="(value, key) in datasetlist"
                      :key="key"
                      @click="handleChange(key, value)"
                    >
                      {{ value }}
                    </a-button>
                  </div>

                  <!-- <a-select
                    style="width: 100%; margin-top: 8px"
                    @change="handleChange"
                    v-model="value"
                  >
                    <a-select-option
                      v-for="(key, value) in this.datasetlist"
                      :key="key"
                      :value="value"
                    >
                      {{ key }}
                    </a-select-option>
                  </a-select> -->
                </div>
              </div></a-col
            >
            <a-col :span="15">
              <div style="margin-top: 15px">
                Step 2 : select genes of interest:
                <geneTable v-bind:datasetId="this.datasetId" /></div
            ></a-col>
          </a-row>
        </a-card>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import geneTable from "./freqTable.vue";

export default {
  components: { geneTable },
  methods: {
    handleChange(key, value) {
      this.value = value;
      // console.log(this.datasetlist[this.value]);
      this.datasetId = this.value;
      console.log(this.datasetId);
    },
  },
  data() {
    return {
      value: "SC00001",
      datasetId: "SC00001",
      datasetlist: [
        "SC00001",
        "SC00002",
        "SC00003",
        "SC00004",
        "SC00005",
        "SC00006",
        "SC00009",
        "SC00012",
        "SC00014",
        "SC00015",
        "SC00019",
        "SC00037",
        "SC00038",
        "SC00039",
        "SC00040",
        "SC00041",
        "SC00042",
        "SC00043",
        "SC00044",
        "SC00045",
        "SC00046",
        "SC00047",
        "SC00049",
        "SC00050",
        "SC00052",
        "SC00053",
        "SC00054",
        "SC00055",
        "SC00058",
        "SC00065",
        "SC00066",
      ],
    };
  },
};
</script>
<style scoped></style>
